import { ImageWithHighlight, Slider, SliderSlide } from "@ui"

interface SliderProps {
  images: { src: string; alt: string }[]
}

export function ArticleSlider(props: SliderProps) {
  const { images } = props

  return (
    <section className="relative mb-9 select-none">
      <Slider
        className="-mr-4 laptop:mr-0"
        options={{
          spaceBetween: 16,
          roundLengths: true,
          slidesPerView: "auto",
          loop: true,
          updateOnWindowResize: true,
          navigation: false,
          breakpoints: {
            320: {
              navigation: false,
              enabled: images.length > 1,
            },
            768: {
              navigation: true,
              slidesPerView: 2,
              enabled: images.length > 2,
            },
            1024: {
              navigation: true,
              slidesPerView: 2,
              enabled: images.length > 2,
            },
          },
        }}
        classes={{
          container: "-m-4 p-4 bg-no-repeat bg-center tablet:ml-2 tablet:mr-0",
        }}
      >
        {images.map((img, index) => (
          <SliderSlide
            key={index}
            className="w-full h-[460px] max-w-[90%] tablet:max-w-none"
          >
            <ImageWithHighlight
              src={img.src}
              alt={img.alt}
              layout="fill"
              objectFit="contain"
              unoptimized={true}
            />
          </SliderSlide>
        ))}
      </Slider>
    </section>
  )
}
